import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { BasketTotalsComponentDef } from '@df/basket/view/basket-totals.component.def';
import { sortBy } from 'lodash';

@Component({
    selector: 'basket-view-totals',
    templateUrl: 'basket-view-totals.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketViewTotalsComponent extends BasketTotalsComponentDef {
    @Input()
    isMinibasket = false;

    readonly hidePaypalPayInThreeMessage = input<boolean>(false);

    get totalsWithChangedOrder() {
        //order of totals
        const totalsList = ['subtotal', 'shipping', 'giftcards', 'discount', 'tax', 'total'];
        return sortBy(this.totals, total => totalsList.indexOf(total.id));
    }

    protected get couponLabel(): string | undefined {
        const coupon = this.basket.data.coupon;
        return Array.isArray(coupon) ? coupon.join(', ') : coupon;
    }
}
